import React, { useState } from 'react';
import { PillButton } from 'library/ui';
import { AddCircleRounded } from '@mui/icons-material';
import { ITeacher } from 'models';
import EditOrCreateNewJobModal from './EditOrCreateNewJobModal';
import { ISpotlightWorker } from 'parent-portal/home/Models/DashboardData';
import { useModalsContext } from 'ModalsContext';
import { teacherToSpotlightWorkerApiObject } from './inviteUtils';

export default function InviteButton({
    selectedWorkers,
    setSelectedWorkers,
}: {
    selectedWorkers: ITeacher[];
    setSelectedWorkers: (selectedWorkers: ITeacher[]) => void;
}) {
    const [inviteModalOpen, setInviteModalOpen] = useState(false);
    const { openJobForm } = useModalsContext();

    function handleInviteClick() {
        setInviteModalOpen(true);
    }

    function request() {
        const normalizedWorkers: ISpotlightWorker[] = selectedWorkers.map(teacherToSpotlightWorkerApiObject);

        setSelectedWorkers([]);

        openJobForm('Teacher Showcase', {
            selectedSpotlightWorkers: normalizedWorkers,
            allSpotlightWorkers: normalizedWorkers,
        });
    }

    function closeAndReset() {
        setInviteModalOpen(false);
        setSelectedWorkers([]);
    }

    return (
        <>
            <PillButton
                onClick={handleInviteClick}
                icon={<AddCircleRounded style={{ fontSize: 20 }} />}
                disabled={selectedWorkers.length === 0}
            >
                Invite Selected Teachers
            </PillButton>
            <EditOrCreateNewJobModal
                open={inviteModalOpen}
                onClose={closeAndReset}
                selectedWorkers={selectedWorkers}
                openJobForm={request}
            />
        </>
    );
}
